import React from 'react';
import { ShimmerSimpleGallery } from 'react-shimmer-effects';

function DashboardSkeleton() {
    return (
        <ShimmerSimpleGallery card imageHeight={250} />
    );
}

export default DashboardSkeleton;
